import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import ProduttivoMuiThemeV2 from '@/components/shared/themes/ProduttivoThemeV2'
import { makeRemoteLoadResourcePlaceList } from '@/javascript/main/factories/usecases'
import { AccountMemberList } from '@/javascript/presentation/pages/account-members'

const rootEl = document.getElementById('account-member-list-filters-root')

export const makeAccountMemberFilters = () => {
  const hasAddMemberPermission = rootEl.getAttribute('data-add-member') === 'true'

  return(
  <ThemeProvider theme={ProduttivoMuiThemeV2}>
    <AccountMemberList
      hasAddMemberPermission={hasAddMemberPermission}
      fetchResourcePlaces={makeRemoteLoadResourcePlaceList()}
    />
  </ThemeProvider>
  )
}

if (rootEl !== null) {
  const root = createRoot(rootEl)
  root.render(makeAccountMemberFilters())
}
